import Dialog from '../../../../common/dialog';
import ShareLink from '../share-link';
import l from '../../../../../lang';

import './styles.scss';

interface ShareLinkModalProps {
  onClose: () => void;
  link: string;
}

const ShareLinkModal = ({ onClose, link }: ShareLinkModalProps) => {
  return (
    <Dialog
      dividers={false}
      title={l(`affiliations.affiliates.shareLinkModal.title`)}
      unpaddingFooter
      fullScreenMobile
      handleClose={onClose}
      type="sm"
      body={
        <div className="payment_link_dialog__share">
          <p className="affiliations__subheadline">{l('affiliations.affiliates.shareLinkModal.description')}</p>
          <ShareLink url={link} />
        </div>
      }
      footer={<div className="payment_link_dialog__share__footer" />}
    />
  );
};

export default ShareLinkModal;
